module.exports = __webpack_public_path__ + "img/idea-score.1c1c71a8.png";